export default {
	title: 'application_settings',
	components: [
		{
			title: 'appliance_type',
			component: 'appliance_type',
		},
		{
			title: 'consumption_calculation',
			component: 'consumption_calculation',
		},
	],
};
